export const API_BASE_URL = "https://ims-backend.indevconsultancy.in/api";
export const API_BASE_URL2 = "https://api-ims.indevconsultancy.in";

export const apiService = {
  async login(username, password) {
    try {
      const res = await fetch(`${API_BASE_URL}/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_name: username,
          password: password,
        }),
      });

      return await res.json();
    } catch (error) {
      console.error("Login API Error:", error);
      throw error;
    }
  },
  async getKitchen() {
    try {
      const res = await fetch(`${API_BASE_URL}/kitchens/`, {method: "GET",headers: {"Content-Type": "application/json"}});
      return await res.json();
    } catch (error) {
      console.error("Kitchen API Error:", error);
      throw error;
    }
  },

  async getDashboardCardBox(payload = {}) {
    try {
      const res = await fetch(`${API_BASE_URL2}/dashboard-data.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("Dashboard API Error:", error);
      throw error;
    }
  },
  async getDashboardPurchecs(payload = {}) {
    try {
      const res = await fetch(`${API_BASE_URL2}/purches-dash-data.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("Dashboard API Error:", error);
      throw error;
    }
  },
  
  async getDashboardV3Data(payload = {}) {
    try {
      const res = await fetch(`${API_BASE_URL2}/dashboard-v3-data.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      return await res.json();
    } catch (error) {
      console.error("DashboardV3 API Error:", error);
      throw error;
    }
  },

  async getProjectMasterList() {
    const res = await fetch(`${API_BASE_URL2}/project_master.php`);
    return await res.json();
  },
  // async getProjectMasterLIst() {
  //   try {
  //     const res = await fetch(`${API_BASE_URL2}/project_master.php`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     return await res.json();
  //   } catch (error) {
  //     console.error("Dashboard API Error:", error);
  //     throw error;
  //   }
  // },
  async getSite(payload = {}) {
    try {
      const res = await fetch(`${API_BASE_URL2}/site_master.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("Dashboard API Error:", error);
      throw error;
    }
  },
};
